import {connect} from '@modifi/redux'
import {compose} from 'ramda'
import {aPush} from '@modifi/router'
import {withSuspense} from '@modifi/plugin-onboarding'

import {FeInputFieldStatus} from '@modifi/enums'
import ExistingLegalRepresentative from './ExistingLegalRepresentative'
import {
  aInitializePage,
  aReset,
  aSavePage,
  selectInitialFormData,
  selectInitializePagePending,
  selectSaveErrorMessage,
  selectSaveHasError,
  selectSavePending,
} from '../store/form'
import {
  selectLegalRepresentativeByExternalId,
  selectLegalRepNameByExternalId,
} from '../../../../data/legal-representatives'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import {SECTION_LEGAL_REPRESENTATIVES} from '../../../../constants/sections'
import {selectIsAnyRoleBasedFieldsVisible} from '../store/selectors'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: Record<string, any>, ownProps: Record<string, any>) => {
  const externalCompanyId = ownProps?.match?.params?.externalCompanyId
  const externalPersonId = ownProps?.match?.params?.externalId

  const isLoading = selectInitializePagePending(state, externalPersonId)
  return {
    externalCompanyId,
    externalPersonId,
    isLoading,
    isValidPersonId:
      isLoading ||
      selectLegalRepresentativeByExternalId(state, externalPersonId)?.externalId ===
        externalPersonId,
    updatePending: selectSavePending(state),
    formData: selectInitialFormData(state, externalPersonId),
    hasError: selectSaveHasError(state),
    errorMessage: selectSaveErrorMessage(state),
    pageIsVerified:
      selectCombinedInputFieldStatusBySectionName(state, SECTION_LEGAL_REPRESENTATIVES) ===
      FeInputFieldStatus.VERIFIED,
    hasAnyRoleBasedFieldsVisible: selectIsAnyRoleBasedFieldsVisible(state),
    legalRepName: selectLegalRepNameByExternalId(state, externalPersonId),
  }
}
const mapDispatchToProps = {
  initialize: aInitializePage,
  onSubmit: aSavePage,
  onDiscard: aReset,
  redirect: aPush,
}

export default compose(
  withSuspense(false),
  connect(mapStateToProps, mapDispatchToProps)
)(ExistingLegalRepresentative)
